var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.75C5.5 18.1875 5.8125 18.5 6.25 18.5H19.25C19.6562 18.5 20 18.8438 20 19.25C20 19.6875 19.6562 20 19.25 20H6.25C5 20 4 19 4 17.75V6.75C4 6.34375 4.3125 6 4.75 6C5.15625 6 5.5 6.34375 5.5 6.75V17.75ZM14.75 9H18.25C18.6562 9 19 9.34375 19 9.75V13.25C19 13.6875 18.6562 14 18.25 14C17.8125 14 17.5 13.6875 17.5 13.25V11.5625L14 15.0312C13.7188 15.3438 13.25 15.3438 12.9688 15.0312L10.4688 12.5625L8.5 14.5312C8.21875 14.8438 7.75 14.8438 7.46875 14.5312C7.15625 14.25 7.15625 13.7812 7.46875 13.4688L9.96875 10.9688C10.25 10.6875 10.7188 10.6875 11 10.9688L13.5 13.4688L16.4375 10.5H14.75C14.3125 10.5 14 10.1875 14 9.75C14 9.34375 14.3125 9 14.75 9Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.f4d625242fbb359009245b4bea12f9db.svg";
export { ForwardRef as ReactComponent };